var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgStarYellow48Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "685DB7BE-C6AC-4875-A121-6366102D768A_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Reklaam",
    transform: "translate(-208.000000, -205.000000)",
    fill: "#FFCD00"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(208.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy",
    transform: "translate(0.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bitmap"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "BG_Star_Yellow-48px",
    points: "24 43.8805804 17.7883429 47.1822198 14.0597098 41.2170876 7.02943725 40.9705627 6.78291237 33.9402902 0.817780169 30.2116571 4.11941964 24 0.817780169 17.7883429 6.78291237 14.0597098 7.02943725 7.02943725 14.0597098 6.78291237 17.7883429 0.817780169 24 4.11941964 30.2116571 0.817780169 33.9402902 6.78291237 40.9705627 7.02943725 41.2170876 14.0597098 47.1822198 17.7883429 43.8805804 24 47.1822198 30.2116571 41.2170876 33.9402902 40.9705627 40.9705627 33.9402902 41.2170876 30.2116571 47.1822198"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgStarYellow48Px);
export default __webpack_public_path__ + "static/media/BG_Star_Yellow-48px.aebd48174284d0bdd771c9d28d4b7170.svg";
export { ForwardRef as ReactComponent };